import React from 'react';

const Finished = ({responces}) => {
  // Calculate  results
  var mapResponces = responces.reduce(function(p, c) {
    p[c] = (p[c] || 0) + 1;
    return p;
  }, {});

  // Ordered by responces then fixed order
  const resultsOrder = {
    'community-outreach': 1,
    'semi-intensive': 2,
    'intensive': 3,
  };
  const winningResult = Object.keys(mapResponces)
    .sort((a, b) => resultsOrder[a] - resultsOrder[b])
    .sort((a, b) => mapResponces[b] - mapResponces[a]);

  // Set term IDs
  const phase = getPhaseId('introduction');
  let intensity = getIntensityId(winningResult[0]);

  // Special rules
  // "1 year" this answer vetos semi-intensive and intensive
  if (responces[4] === 'community-outreach') {
    intensity = getIntensityId('community-outreach');
  }
  // "2-3 Years" This vetos intensive, but could still permit SOC
  else if (responces[4] === 'semi-intensive' && winningResult[0] === 'intensive') {
    intensity = getIntensityId('semi-intensive');
  }

  // Redirect
  window.location.href = `/${lang.LANG}/${lang.RESULTS_PAGE_URI}?phase=${phase}&intensity=${intensity}`;

  return '';
}


// Find and return the phase & intensity taxonomy term IDs
function getPhaseId(phase) {
  if (lang.PHASES[phase]) {
    return lang.PHASES[phase];
  }
}
function getIntensityId(intensity) {
  if (lang.INTENSITIES[intensity]) {
    return lang.INTENSITIES[intensity];
  }
}


export default Finished;
